module.exports = __webpack_public_path__ + "img/white-add.59512f4a.svg";